import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
  Spinner,
  Label,
  Row,
} from 'reactstrap';
import logo from '../../assets/img/brand/logo.png';
import { apiURL1 } from '../../config';
import ReCAPTCHA from "react-google-recaptcha";



const Login = () => {
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({ email: '', password: '', captchaValue: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const siteKey = process.env.REACT_APP_RECAPTA_SITE_KEY;
  // console.log("Recaptcha Site Key:", siteKey);



  const handleCaptchaChange = (value) => {
    // console.log('captchaValue is ', value)
    setCaptchaValue(value);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prevData) => ({ ...prevData, [name]: value }));
  };

  const getLayoutAndRoute = (role) => {
    const routes = {
      superadmin: '/admin/index',
      student: '/student/index',
      teacher: '/staff/index',
    };
    // console.log('routes[role] ', routes[role])
    return routes[role] || '/auth/login';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loginData.email || !loginData.password) return;
    if (!captchaValue) {
      alert("Please verify the reCAPTCHA!");
      return;
    }

    loginData.captchaValue = captchaValue;

    setIsLoading(true);
    try {
      const response = await fetch(`${apiURL1}/superadmin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginData),
      });

      if (!response.ok) throw new Error('Login failed. Please check your credentials.');

      const admin = await response.json();
      const route = getLayoutAndRoute(admin?.role);
      localStorage.setItem("role", admin.role);
      localStorage.setItem("token", admin.token);
      localStorage.setItem("userInfo", JSON.stringify(admin.user));


      // console.log('Rec route is ', route)
      navigate(route);
      window.location.reload();
      setLoginData({ email: '', password: '' });
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Col lg='5' md='7'>
      <Card className='bg-secondary shadow border-0'>
        <CardBody className='px-lg-5 py-lg-5'>
          <Row className='align-items-center justify-content-center mb-4'>
            <Col xs='auto' className='px-2'>
              <img width={'150px'} src={logo} className='mx-auto d-block' alt='Logo' />
            </Col>
          </Row>
          <div className='text-center text-muted mb-4'>
            <small>Sign in with credentials!</small>
          </div>
          <Form onSubmit={handleSubmit}>
            <FormGroup className='mb-3'>
              <InputGroup className='input-group-alternative'>
                <InputGroupAddon addonType='prepend'>
                  <InputGroupText>
                    <i className='ni ni-email-83' />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder='Email'
                  type='email'
                  name='email'
                  value={loginData.email}
                  onChange={handleChange}
                  autoComplete='email'
                />
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <InputGroup className='input-group-alternative'>
                <InputGroupAddon addonType='prepend'>
                  <InputGroupText>
                    <i className='ni ni-lock-circle-open' />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder='Password'
                  type='password'
                  name='password'
                  value={loginData.password}
                  onChange={handleChange}
                  autoComplete='current-password'
                />
              </InputGroup>
            </FormGroup>
            <div className='text-right'>
              <Link to='/auth/forgot-password'>Forgot Password?</Link>
            </div>
            <FormGroup check>
              <Label check>
                <Input type='checkbox' /> Remember me
              </Label>
            </FormGroup>
            <ReCAPTCHA
              sitekey={siteKey}
              onChange={handleCaptchaChange}
            />
            <div className='text-center'>
              <Button className='my-4' color='danger' disabled={isLoading || !loginData.email || !loginData.password}>
                {isLoading ? <Spinner size='sm' /> : 'Sign in'}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>

  );
};

export default Login;
